import { getName } from "src/pages/propinas/home/helpers/name"
import { capitalize } from "src/shared/helpers/capitalize"
import { getCurrencyFormat } from "src/utils/string"
import { DetallePago, HistorialEstadoOrden } from "src/gql/schema"
import Status from "../components/cell/Status"
import './formatRows.css'

const getPaymentKey = (keys?: DetallePago[] | null) => {
    if ((keys?.length || 0) > 0) {
        if ((keys?.length || 0) > 1) {
            return "mixto"
        } else {
            return keys?.[0]?.tipo_pago || ""
        }
    } else {
        return ""
    }
}

export const formatRoomServiceMostradorRows = (list: HistorialEstadoOrden[], formatCustomDate: (fecha: any, mask: string) => string) => {
    const orderList =
        list.sort((a, b) => new Date(b.fecha_registro).getTime() - new Date(a.fecha_registro).getTime()) || []

    return orderList.map((i) => {
        const orden = i?.orden
        const base = [
            { value: orden?.orden || "-" },
            { value: orden?.turno?.nombre || "-" },
            {
                value: orden?.fecha_registro
                    ?
                    <span style={{ whiteSpace: "nowrap" }}>
                        {formatCustomDate(orden?.fecha_registro, "DD/MMM/YYYY")}&nbsp;
                        {formatCustomDate(orden?.fecha_registro, "hh:mm a")}
                    </span>
                    : "-",
            },

            {
                value: orden?.colaborador_entrega ? getName(orden?.colaborador_entrega) : "-",
            },
            ...(i.orden?.renta?.habitacion ? [{
                value: <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className="table-historial-movimientos__origen__type">{i.orden.renta.habitacion.tipo_habitacion?.nombre}</span>
                    <span className="table-historial-movimientos__origen__number">{i.orden.renta.habitacion.numero_habitacion}</span>
                </div>,
            }] : []),
            {
                value: getCurrencyFormat(orden?.total_con_iva || 0),
            },
            { value: capitalize(getPaymentKey(orden?.pago?.detalles_pago)) || "N/A" },
            { value: i?.tiempo_en_preparacion },
            { value: i?.tiempo_por_entregar },
            { value: i?.tiempo_en_entrega },
            { value: i?.tiempo_total },
            {
                value: <Status
                    statusOrden={orden?.estado_orden}
                    statusOrdenPago={orden?.estado_pago}
                />,
            },
        ]
        return {
            value: base,
        }
    })
}

export const formatRestaurantRows = (list: any[], formatCustomDate: (fecha: any, mask: string) => string) => {
    const orderList =
        list.sort(
            (a, b) => new Date(b.comanda?.fecha_registro).getTime() - new Date(a.comanda?.fecha_registro).getTime()
        ) || []

    return orderList.map((i) => {
        const comanda = i?.comanda
        const orden = comanda?.orden

        const base = [
            { value: orden?.orden || "-" },
            { value: comanda?.folio || "-" },
            { value: "Mesa " + (orden?.mesa?.numero_mesa || "-") },
            {
                value: `${orden?.turno?.nombre || "-"}\n${formatCustomDate(comanda?.fecha_registro, "HH:mm:ss") || "-"}`,
            },
            { value: orden?.colaborador_entrega ? getName(orden?.colaborador_entrega) : "-" },
            { value: getCurrencyFormat(comanda?.total_comanda || 0) },
            { value: capitalize(getPaymentKey(orden?.pago?.detalles_pago)) || "N/A" },
            { value: i?.tiempo_en_preparacion },
            { value: i?.tiempo_por_entregar },
            { value: i?.tiempo_total },
            {
                value: <Status
                    statusOrden={orden?.estado_orden}
                    statusOrdenPago={orden?.estado_pago}
                />,
            }
        ]
        return {
            value: base,
        }
    })
}
